import * as yup from 'yup';

import { endpoint, EndpointError } from 'endpoints/endpoint';

import { ERROR as VALIDATION_ERROR } from '../validation';

export type SendErrorReportParams = { userId?: string; roomId: string; errorName: string; errorMessage: string };
export type SendErrorReportResult = { data: 'OK' };
export type SendErrorReportError = EndpointError;

export const sendErrorReport = endpoint<SendErrorReportParams, SendErrorReportResult, SendErrorReportError>({
  method: 'POST',
  url: () => '/logs/error-report',
});

export const sendErrorReportParamsSchema: yup.SchemaOf<SendErrorReportParams> = yup.object().shape({
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
  userId: yup.string().optional(),
  errorName: yup.string().required(VALIDATION_ERROR.REQUIRED),
  errorMessage: yup.string().required(VALIDATION_ERROR.REQUIRED),
});
